export class EmptyPayloadException extends Error {

  constructor(message: string) {
    super(message)
    Object.setPrototypeOf(this, EmptyPayloadException.prototype)
  }
}

export default EmptyPayloadException
